import { render, staticRenderFns } from "./Contatto-rinnovo.vue?vue&type=template&id=bdccb2fe&"
import script from "./Contatto-rinnovo.vue?vue&type=script&lang=js&"
export * from "./Contatto-rinnovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports